import { type ForwardedRef, forwardRef, type SelectHTMLAttributes } from "react";

interface SelectInputProps extends SelectHTMLAttributes<HTMLSelectElement> {
    id: string;
    labelText?: string;
    required?: boolean;
    isInvalid?: boolean;
    errorMessage?: string;
    placeholder?: string;
    options: Array<Record<string, string>>;
    currentValue?: string;
}

const SelectInput = (
    {
        id,
        labelText,
        required,
        isInvalid,
        options,
        currentValue,
        placeholder,
        errorMessage,
        ...rest
    }: SelectInputProps,
    ref: ForwardedRef<HTMLSelectElement>
) => {
    return (
        <div className="form-group mb-4">
            {labelText && (
                <label htmlFor={id}>
                    {labelText}
                    {required ? <span className="text-danger">*</span> : ""}
                </label>
            )}

            <select
                id={id}
                className={`form-control mb-0 ${isInvalid ? "is-invalid" : ""}`}
                required={required}
                ref={ref}
                {...rest}
            >
                <option value="">
                    {placeholder ?? (!placeholder && labelText && `Select ${labelText}`)}
                </option>
                {Array.isArray(options) &&
                    options &&
                    options.length > 0 &&
                    options.map((option, index) => {
                        return (
                            <option key={index} value={option.id}>
                                {option.name}
                            </option>
                        );
                    })}
            </select>

            {isInvalid && <div className="invalid-feedback">{errorMessage ?? "Invalid Value"}</div>}
        </div>
    );
};

export default forwardRef<HTMLSelectElement, SelectInputProps>(SelectInput);
